import _ from 'underscore';
import { LabelsDataSource } from '@bingads-webui-campaign/labels';
import labelNameTemplate from '../shared/label-name-template.pug';

let i18n = null;
let schemaI18nCampaign = null;
let cacheService = null;
let dataContextManager = null;
let jsdata = null;
let edm = null;
let scope = null;

export function initialize(options) {
  ({
    i18n,
    schemaI18nCampaign,
    cacheService,
    dataContextManager,
    jsdata,
    edm,
    scope,
  } = options);
}

function getLabel(value, customerLevelLabelEnabled) {
  const newValue = JSON.parse(value);
  return {
    Id: newValue.Id ? newValue.Id : value,
    Scope: customerLevelLabelEnabled && newValue.Scope ? newValue.Scope : undefined,
  };
}

function wrapFilterExpression(filterExpression, secondLogic) {
  const fieldPrefix = 'd:';
  return `Labels/${secondLogic}(${fieldPrefix}${filterExpression})`;
}

function buildLabelFilter(value, operator, secondLogic, wrapFilter, customerLevelLabelEnabled) {
  const label = getLabel(value, customerLevelLabelEnabled);
  const fieldId = 'd/Id';
  let secondaryOperator = 'and';
  if (operator === 'ne') {
    secondaryOperator = 'or';
  }

  let filter = `${fieldId} ${operator} ${label.Id}`;
  if (label.Scope) {
    const fieldScope = 'd/Scope';
    filter += ` ${secondaryOperator} ${fieldScope} ${operator} Enum.EntityScope'${label.Scope}'`;
  }

  if (wrapFilter) {
    filter = wrapFilterExpression(filter, secondLogic);
  }

  return filter;
}

function lambdaConvertForLabels(logic, secondLogic, operator, customerLevelLabelEnabled) {
  return (values) => {
    let url = '';
    const wrapInnerFilter = !(logic === 'or' && !customerLevelLabelEnabled);
    _.each(values, (value, index) => {
      if (index > 0) {
        url += ` ${logic} `;
      }
      url +=
        buildLabelFilter(value, operator, secondLogic, wrapInnerFilter, customerLevelLabelEnabled);
    });
    if (!wrapInnerFilter) {
      url = wrapFilterExpression(url, secondLogic);
    }
    if (logic === 'or') {
      url = `(${url})`;
    }
    return url;
  };
}

export function updateEntitySchemaForLabels(entitySchema, customerLevelLabelEnabled = false) {
  const entitySchemaCopy = entitySchema;
  entitySchemaCopy.properties.Labels = {
    property: 'Labels',
    name: schemaI18nCampaign.property('Campaign', 'Labels'),
    title: schemaI18nCampaign.property('Campaign', 'Labels'),
    operatorDisplayNameMap: {
      containsall: i18n.getString('FilterOperator_ContainsAll'),
      containsany: i18n.getString('FilterOperator_ContainsAny'),
      containsnone: i18n.getString('FilterOperator_ContainsNone'),
    },
    operators: ['containsall', 'containsany', 'containsnone'],
    type: 'id',
    addtionalParams: {
      dataSource: new LabelsDataSource({
        cacheService,
        dataContextManager,
        jsdata,
        edm,
        scope,
        customerLevelLabelEnabled,
      }),
      templates: customerLevelLabelEnabled ? {
        nameTemplate: labelNameTemplate,
      } : undefined,
    },
    filterable: true,
  };
  return entitySchemaCopy;
}

export function updateOdataOptionsForLabels(options, customerLevelLabelEnabled = false) {
  if (options) {
    const optionsCopy = options || { custom: {} };

    _.extendOwn(optionsCopy.custom, {
      Labels: {
        containsall: lambdaConvertForLabels('and', 'any', 'eq', customerLevelLabelEnabled),
        containsany: lambdaConvertForLabels('or', 'any', 'eq', customerLevelLabelEnabled),
        containsnone: lambdaConvertForLabels('and', 'all', 'ne', customerLevelLabelEnabled),
      },
    });
    return optionsCopy;
  }
  return options;
}
